import { useSetImmerAtom } from 'jotai-immer';
import { useEffect, useRef } from 'react';
import { tableStateVM, tableDataVM, tableViewVM, tableStatsVM } from '../../../../core/table/table_view_models';
import {
    providerPageStateAtom,
    providerSearchFormAtom,
    tableStateAtom,
    providerDataAtom,
    tableViewAtom,
    tableStatsAtom,
    tableFiltersAtom,
    setAtomProviderListTableViewState,
} from '../provider_list_atoms';
import { ProviderDataItem } from '../provider_list_types';
import { providerPageStateVM, providerSearchStateVM } from '../provider_list_view_models';

export const useProviderListDestroy = (): void => {
    const atomsDestroyed = useRef(false);
    // page
    const setPageState = useSetImmerAtom(providerPageStateAtom);

    // form
    const setSearchForm = useSetImmerAtom(providerSearchFormAtom);

    // table
    const setTableState = useSetImmerAtom(tableStateAtom);
    const setTableData = useSetImmerAtom(providerDataAtom);
    const setView = useSetImmerAtom(tableViewAtom);
    const setStats = useSetImmerAtom(tableStatsAtom);
    const setFilter = useSetImmerAtom(tableFiltersAtom);

    useEffect(() => {
        atomsDestroyed.current = false;

        return (): void => {
            // page
            setPageState(() => providerPageStateVM());
            // form
            setSearchForm(() => providerSearchStateVM());
            // table
            setAtomProviderListTableViewState();
            setTableState(() => tableStateVM());
            setTableData(() => tableDataVM<ProviderDataItem>());
            setView(() => tableViewVM());
            setStats(() => tableStatsVM());
            setFilter(() => ({}));

            // mark atoms destroyed
            atomsDestroyed.current = true;
        };
    }, [setPageState, setSearchForm, setTableState, setTableData, setView, setStats, setFilter]);
};
